import { Result, Button } from "antd";
import { auth } from "~/lib/firebase";
import {
  ActionFunctionArgs,
  LoaderFunctionArgs,
  redirect,
  useRouteError,
} from "react-router-dom";
import {
  apiClient,
  LeaseDetailsLoaderResult,
} from "~/services/apiClient";
import * as APITypes from "~/API";
import { INTENTS } from "~/utils";

export const LeaseDetailsPageLoader = async ({
  params,
}: LoaderFunctionArgs) => {
  const user = auth.currentUser;
  if (!user) return redirect("/signup");

  const leaseID = params.leaseID || "";
  if (!leaseID) return redirect("/lease");

  const result = await apiClient.loader<LeaseDetailsLoaderResult>(
    "lease-details",
    { id: leaseID }
  );

  if (!result.success || !result.data) {
    console.error("Lease details loader failed:", result.error);
    throw new Response(result.error ?? "Failed to load lease", { status: 500 });
  }

  return result.data;
};

export type LeaseDetailsPageLoaderType = {
  entityDetails: APITypes.Unit | APITypes.Building;
  userID: string;
  userName: string;
  formattedLease: LeaseDetailsLoaderResult["formattedLease"];
};

export const LeaseDetailsPageAction = async ({
  params,
}: ActionFunctionArgs) => {
  const leaseID = params.leaseID || "";
  if (!leaseID) {
    throw new Response("Lease ID required", { status: 400 });
  }

  const result = await apiClient.sendIntent<APITypes.Offer>(
    INTENTS._sign_offer,
    { leaseID }
  );

  if (!result.success) {
    throw new Response(result.error ?? "Failed to sign lease", { status: 500 });
  }

  return result.data;
};

export const LeaseDetailsPageErrorBoundary = () => {
  const error = useRouteError();
  console.error("Unit details lease page error", error);
  return (
    <Result status="500" title="500" subTitle="Sorry, something went wrong.">
      <div style={{ display: "flex", justifyContent: "center" }}>
        <Button type="primary" href="/">
          Back Home
        </Button>
      </div>
    </Result>
  );
};
